import React, { FC, useEffect } from 'react';
import { LiveTableProps } from "../../types";
import { TableContainer } from "../../styles";
import { Table } from "antd";
import { TableColumn } from "../../../../components/Table";

export const LiveTable: FC<LiveTableProps> = ({ data, captureChannel, anticipationFee, digitalAnticipationFee }) => {
  const formattScreenFees = (fee: number | null) => {
    if (!fee) return '-';
    return `${fee.toString().replace('.', ',')}%`;
  };

  const formattCaptureChannel = (channel: number) => {
    return channel === 0 ? 'POS' : 'E-commerce';
  };


  return (
    <div>
      <TableContainer>
        <Table
          dataSource={data}
          pagination={false}
        >
          <TableColumn
            title={<span style={{ fontSize: "14px", fontWeight: 600 }}>Tipo (modalidade)</span>}
            dataIndex="modality"
            key="modality"
            align="center"
            render={(value) => <strong>{value}</strong>}
          />
          <TableColumn title={
            <img
              src="https://raw.githubusercontent.com/aaronfagan/svg-credit-card-payment-icons/main/flat-rounded/visa.svg"
              alt="Visa"
              style={{ width: 75, height: 75 }}
            />
          } dataIndex={['fees', 'visa']} key="visa" render={formattScreenFees} align="center" />
          <TableColumn title={
            <img
              src="https://raw.githubusercontent.com/aaronfagan/svg-credit-card-payment-icons/main/flat-rounded/mastercard.svg"
              alt="Mastercard"
              style={{ width: 75, height: 75 }}
            />
          } dataIndex={['fees', 'mastercard']} key="mastercard" render={formattScreenFees} align="center" />
          <TableColumn title={
            <img
              src="https://raw.githubusercontent.com/arthurmourab/svg-credit-card-payment-icons/refs/heads/main/flat-rounded/elo.svg"
              alt="Elo"
              style={{ width: 75, height: 75 }}
            />
          } dataIndex={['fees', 'elo']} key="elo" render={formattScreenFees} align="center" />
          <TableColumn title={
            <img
              src="https://raw.githubusercontent.com/aaronfagan/svg-credit-card-payment-icons/main/flat-rounded/amex.svg"
              alt="Amex"
              style={{ width: 75, height: 75 }}
            />
          } dataIndex={['fees', 'amex']} key="amex" render={formattScreenFees} align="center" />
          <TableColumn title={
            <img
              src="https://raw.githubusercontent.com/aaronfagan/svg-credit-card-payment-icons/main/flat-rounded/hipercard.svg"
              alt="Hipercard"
              style={{ width: 75, height: 75 }}
            />
          } dataIndex={['fees', 'hipercard']} key="hipercard" render={formattScreenFees} align="center" />
          <TableColumn
            title={<span style={{ fontSize: "14px", fontWeight: 600 }}>Prazo de recebimento</span>}
            dataIndex="settlement"
            key="settlement"
            align="center"
            render={(value, record, index) => {
              const posFee = anticipationFee ?? 0;
              const digitalFee = digitalAnticipationFee ?? 0;

              if (captureChannel === 1) {
                if (digitalFee > 0) return "D+1";
                return `D+${index === 0 ? 1 : index * 30}`;
              }
              if (posFee > 0) return "D+1";
              return `D+${index === 0 ? 1 : index * 30}`;
            }}


          />
          <TableColumn
            title={<span style={{ fontSize: "14px", fontWeight: 600 }}>Canal de captura</span>}
            dataIndex="captureChannel"
            key="captureChannel"
            render={formattCaptureChannel}
            align="center"
          />
        </Table>
      </TableContainer>
    </div>
  )
}
